class categoriesIndexPage {

    constructor() {

        const swiper = new Swiper("#index-page-thumbnail-swiper", {
            slidesPerView: 2,
            spaceBetween: 16,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    slidesPerView: 4
                }
            }
        });
        const swiper2 = new Swiper("#index-page-swiper", {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 16,
            autoplay: {
                delay: 4000
            },
            navigation: {
                "prevEl": "#prev",
                "nextEl": "#next"
            },
            thumbs: {
                swiper: swiper,
            },
        });
    }
}

export let CategoriesIndexPage = new categoriesIndexPage();
